import M from 'utils/Mapea';
import Utils from 'utils/Utils';
import LocalStorage from 'utils/LocalStorage';

import MAPA from 'static/img/mapa.png';
import IMAGEN from 'static/img/image.png';
import HIBRIDO from 'static/img/hibrido.png';

declare var ol;
declare var PRECHARGED;
declare var CONFIGURATIONS;

export let mapjs;

export const initMap = (unblock, t, params) => {
  const lang = LocalStorage.getString('language') || 'es';
  M.language.setLang(lang);
  let zoom = 5;
  let center = [-17181.402054092905, 4716045.89913776];
  let mouseProjection = 'EPSG:4326';
  try {
    const arrayParams = params.split('&');
    arrayParams.forEach((param) => {
      if (param.indexOf('center') > -1) {
        const values = param.split('=')[1].split(',');
        center = [parseFloat(values[0]), parseFloat(values[1])];
      } else if (param.indexOf('zoom') > -1) {
        const value = param.split('=')[1];
        zoom = parseInt(value, 10);
      } else if (param.indexOf('srs') > -1) {
        const value = param.split('=')[1];
        mouseProjection = value;
      }
    });

    if (center[0] !== -17181.402054092905 && center[1] !== 4716045.89913776) {
      center = ol.proj.transform(center, mouseProjection, 'EPSG:3857');
    }
  } catch (err) {}

  if (Utils.isMobile()) {
    mapjs = M.map({
      container: 'map',
      controls: ['location', 'rotate'],
      center: center,
      zoom: zoom,
      minZoom: 5,
      maxZoom: 20,
    });

    window.mapjs = mapjs;
    mapjs.addPlugin(getConfiguredBaseLayersPlugin(t));
    // mapjs.addPlugin(new M.plugin.FullTOC({
    //   collapsed: true,
    //   position: 'TL',
    //   https: true,
    //   http: true,
    //   precharged: PRECHARGED,
    //   codsi: true,
    // }));

    mapjs.addPlugin(
      new M.plugin.Layerswitcher({
      collapsed: true,
      position: 'TL',
      https: true,
      http: true,
      isDraggable: false,
      modeSelectLayers: 'eyes',
      tools: ['transparency', 'legend', 'zoom', 'information', 'style', 'delete'],
      isMoveLayers: true,
      https: true,
      http: true,
      showCatalog: true,
      precharged: PRECHARGED,
      order: -98,
    }));

    // mapjs.addPlugin(
    //     new M.plugin.IGNSearchLocator({
    //     servicesToSearch: 'gn',
    //     maxResults: 10,
    //     isCollapsed: false,
    //     collapsible: true,
    //     position: 'TL',
    //     reverse: true,
    //     cadastre: false,
    //     searchCoordinatesXYZ: false,
    //     noProcess: '-',
    //   })
    // );

    const mp_Locator = new M.plugin.Locator({
      position: 'TR',
      useProxy: false,
      collapsible: true,
      collapsed: false,
      zoom: 16,
      pointStyle: 'pinAzul',
      byParcelCadastre: true,
      byCoordinates: true,
      byPlaceAddressPostal: {
        servicesToSearch: 'g',
        servicesToSearch: 'g',
        maxResults: 33,
        noProcess: 'expendeduria',
        reverse: false,
        searchPosition: 'geocoder',
      },
      isDraggable: false,
    });
    
    mapjs.addPlugin(mp_Locator);


  } else {
    mapjs = M.map({
      container: 'map',
      controls: ['scale*true'],
      center: center,
      zoom: zoom,
      minZoom: 5,
      maxZoom: 20,
    });

    window.mapjs = mapjs;

    mapjs.addPlugin(getConfiguredBaseLayersPlugin(t));
    mapjs.addPlugin(new M.plugin.Information({ position: 'TR' }));
    mapjs.addPlugin(new M.plugin.MeasureBar({ position: 'TR' }));
    mapjs.addPlugin(new M.plugin.Attributions({ mode: 1, scale: 10000 }));
    // mapjs.addPlugin(new M.plugin.FullTOC({
    //   collapsed: false,
    //   collapsible: true,
    //   position: 'TL',
    //   https: true,
    //   http: true,
    //   precharged: PRECHARGED,
    //   codsi: true,
    // }));

    mapjs.addPlugin(
      new M.plugin.Layerswitcher({
      collapsed: false,
      position: 'TL',
      https: true,
      http: true,
      isDraggable: false,
      modeSelectLayers: 'eyes',
      tools: ['transparency', 'legend', 'zoom', 'information', 'style', 'delete'],
      isMoveLayers: true,
      https: true,
      http: true,
      showCatalog: true,
      precharged: PRECHARGED,
      order: -98,
    }));

    // mapjs.addPlugin(new M.plugin.ZoomPanel({
    //   position: 'TL',
    //   collapsed: true,
    //   center:  [-17181.402054092905, 4716045.89913776],
    //   zoom: 5,
    // }));

    mapjs.addPlugin(
      new M.plugin.ViewManagement({
        position: 'TL',
        collapsed: true,
        tooltip: 'Gestión de la vista',
        predefinedZoom: [
          {name: 'zoom 1', center: [-428106.86611520057, 4334472.25393817], zoom: 4}
        ],
        zoomExtent: true,
        viewhistory: true,
        zoompanel: true,
      })
    );


    // mapjs.addPlugin(
    //     new M.plugin.IGNSearchLocator({
    //     servicesToSearch: 'gn',
    //     maxResults: 10,
    //     isCollapsed: false,
    //     collapsible: true,
    //     position: 'TL',
    //     reverse: true,
    //     cadastre: false,
    //     searchCoordinatesXYZ: false,
    //     noProcess: '-',
    //   })
    // );

    const mp_Locator = new M.plugin.Locator({
      order: -99,
      position: 'TL',
      useProxy: false,
      collapsible: true,
      collapsed: false,
      zoom: 16,
      pointStyle: 'pinAzul',
      byParcelCadastre: true,
      byCoordinates: true,
      byPlaceAddressPostal: {
        servicesToSearch: 'g',
        maxResults: 33,
        noProcess: 'expendeduria',
        reverse: false,
        searchPosition: 'geocoder',
      },
      isDraggable: false,
    });
    
    mapjs.addPlugin(mp_Locator);

    mapjs.addPlugin(new M.plugin.Popup({
      position: 'BL',
      collapsed: true,
      url_es: CONFIGURATIONS.url_help_es,
      url_en: CONFIGURATIONS.url_help_en,
    }));

    mapjs.addPlugin(new M.plugin.OverviewMap({
      position: 'BR',
      fixed: true,
      zoom: 4,
      baseLayer: 'WMTS*https://www.ign.es/wmts/mapa-raster?*MTN*GoogleMapsCompatible*Cartografía del IGN*false*image/png*false*false*true',
      collapsed: true,
      collapsible: true,
    }));

    mapjs.addPlugin(new M.plugin.MouseSRS({
      position: 'BL',
      tooltip: t('visor.coordinates'),
      srs: mouseProjection,
      label: mouseProjection,
      precision: 4,
      geoDecimalDigits: 6,
      utmDecimalDigits: 2,
      activeZ: true,
    }));
  }

  mapjs.getMapImpl().once('postrender', (evt) => {
      unblock();
      setTimeout(() => {
        document.querySelector('#m-layerswitcher-addlayers.m-layerswitcher-addservice').click();
      }, 500);
      let elemLayerSwitcher = document.querySelector('.m-panel.m-plugin-layerswitcher');
      elemLayerSwitcher.style.setProperty('order', '-98', 'important');
      let elemLocator = document.querySelector('.m-panel.m-plugin-locator.opened');
      elemLocator.style.setProperty('order', '-99', 'important');
      let elemLocatorActive = document.querySelector('#m-locator-ignsearch');
      elemLocatorActive.click()

    });
};

export const isLoadedMap = () => mapjs !== undefined;

export const addWMSLayer = (name, legend, url, version, tiled, options) => {
  const args = {
    name: name,
    url: url,
    legend: legend,
    transparent: true,
    tiled: tiled,
    version: version,
  };

  const layer = new M.layer.WMS(args, options);

  layer.options.visibility = options.visibility;
  layer.options.displayInLayerSwitcher = options.displayInLayerSwitcher;
  layer.options.queryable = options.queryable;

  if (options && options.hasOwnProperty('visibility')) {
    layer.setVisible(options.visibility);
  }

  if (options && options.hasOwnProperty('displayInLayerSwitcher')) {
    layer.displayInLayerSwitcher = options.displayInLayerSwitcher;
  }

  if (options && options.hasOwnProperty('zIndex')) {
    layer.setZIndex(options.zIndex);
  }

  mapjs.addLayers(layer);
  return layer.getImpl().getExtent();
};

const getConfiguredBaseLayersPlugin = (t) => {
  return new M.plugin.BackImgLayer({
    position: 'TR',
    layerId: 0,
    layerVisibility: true,
    collapsed: true,
    collapsible: true,
    columnsNumber: 3,
    layerOpts: [
      {
        id: 'mapa',
        preview: MAPA,
        title: t('visor.street_map'),
        layers: [
          new M.layer.WMTS({
            url: 'https://www.ign.es/wmts/ign-base?',
            name: 'IGNBaseTodo',
            legend: t('visor.street_map'),
            matrixSet: 'GoogleMapsCompatible',
            transparent: false,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            format: 'image/jpeg',
          }),
        ],
      },
      {
        id: 'imagen',
        preview: IMAGEN,
        title: t('visor.image'),
        layers: [
          new M.layer.XYZ({
            url: 'https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg',
            name: 'PNOA-MA',
            legend: t('visor.image'),
            projection: 'EPSG:3857',
            transparent: false,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            tileGridMaxZoom: 19,
          }),
        ],
      },
      {
        id: 'hibrido',
        title: t('visor.hybrid'),
        preview: HIBRIDO,
        layers: [
          new M.layer.XYZ({
            url: 'https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg',
            name: 'PNOA-MA',
            legend: t('visor.image'),
            projection: 'EPSG:3857',
            transparent: false,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            tileGridMaxZoom: 19,
          }),
          new M.layer.WMTS({
            url: 'https://www.ign.es/wmts/ign-base?',
            name: 'IGNBaseOrto',
            matrixSet: 'GoogleMapsCompatible',
            legend: t('visor.toponyms'),
            transparent: true,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            format: 'image/png',
          }),
        ],
      },
    ],
  });
}
